<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<div id="navbar" class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="assessment.loaded == 0" />
					<div v-if="assessment.loaded != 0" class="navbar-text nav-title flex" id="pageTitle">
						{{ assessment.name }}
					</div>
				</div>
				<div class="content-main" style="background-color:white">
					<!-- Page content goes here -->
					<div class="h-100" v-if="assessment.loaded != 0">
						<div class="d-sm-flex b-t h-100">
							<div class="w w-auto-xs light bg b-r">
								<div class="py-3">
									<div class="nav-active-border left b-primary">
										<ul class="nav flex-column nav-sm">
											<li class="nav-item">
												<a
													class="nav-link nowrap"
													:class="{ active: tab == 1, show: tab == 1 }"
													href="#"
													data-toggle="tab"
													data-target="#tab-1"
												>
													Template Details
													<i
														class="valid-hint text fa fa-angle-left"
														style="margin-right: -1rem;"
														:class="{ invalid: !valid.group('details') }"
													></i>
												</a>
											</li>

											<li class="nav-item">
												<a
													class="nav-link"
													:class="{ active: tab == 3, show: tab == 3 }"
													href="#"
													data-toggle="tab"
													data-target="#tab-3"
												>
													{{ $t("label.page.scoring_setup") }}
													<i
														class="valid-hint text fa fa-angle-left"
														:class="{ invalid: !valid.group('scoring') }"
													></i>
												</a>
											</li>
											<li class="nav-item">
												<a
													class="nav-link"
													:class="{ active: tab == 4, show: tab == 4 }"
													href="#"
													data-toggle="tab"
													data-target="#tab-4"
													>{{ $t("label.page.viewer_controls") }}</a
												>
											</li>
											<li class="nav-item">
												<a
													class="nav-link"
													:class="{ active: tab == 5, show: tab == 5 }"
													href="#"
													data-toggle="tab"
													data-target="#tab-5"
													>Test Design </a
												>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<edit-pane :cancel="loadData" :save="saveAssessment" :dirty="dirty" :valid="valid">
								<div class="tab-content">
									<!-- Item Details -->
									<div class="tab-pane" :class="{ active: defaultTab, show: defaultTab }" id="tab-1">
										<div class="p-4 b-b _600 nav-title">Template Details</div>
										<div role="form" class="col-12 col-lg-8">
											<div class="row m-0 pt-4">
												<div class="col-12">
													<div class="form-group" :class="{ invalid: !valid.field('name') }">
														<label>Template Name</label>
														<input
															type="text"
															class="form-control"
															v-model="assessment.name"
														/>
													</div>
												</div>
												<div class="col-12">
													<div
														class="form-group"
														:class="{
															invalid: !(
																valid.field('ref') &&
																valid.field('ref_char') &&
																valid.field('ref_unique')
															)
														}"
													>
														<label>Reference ID</label>
														<input
															type="text"
															class="form-control"
															v-model="assessment.ref_id"
														/>
														<small class="form-text text-muted"
															>Reference ID must be unique within this tenant</small
														>
													</div>
												</div>
											
											</div>
										</div>
									</div>

									<!-- Scoring Setup -->
									<item-edit-scoring
										id="tab-3"
										:item="assessment"
										:dirty="dirty"
										:valid="valid"
										:defaultTab="tab == 3"
                                        :template="true"
									></item-edit-scoring>

									<!-- Viewer Controls -->
									<item-edit-viewer
										id="tab-4"
										:item="assessment.item"
										:defaultTab="tab == 4"
									></item-edit-viewer>
									<!-- Viewer Controls -->
									<test-designer
										id="tab-5"
										v-model="assessment.test"
                                        :assessment="assessment"
										:defaultTab="tab == 5"
									></test-designer>

								</div>
								<!-- Item Details -->
							</edit-pane>
							<save-optional-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveAssessment"
								:next="saveOptNext"
								:cancel="saveOptCancel"
								objectText="Assessment"
								:objectName="assessment.name"
								actionText="leave the page"
								v-model="saveOptModal"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import RichText from "@/components/RichText";
import AssessmentEditDetails from "@/components/assessment/AssessmentEditDetails";
import AssessmentAssign from "@/components/assessment/AssessmentAssign";
import TestDesigner from "@/components/assessment/TestDesigner";

import ConfigStandardSearch from "@/components/ConfigStandardSearch";
import ItemEditDetails from "@/components/item/ItemEditDetails";
import ItemEditScoring from "@/components/item/ItemEditScoring";
import ItemEditViewer from "@/components/item/ItemEditViewer";

import AssessmentService from "@/services/AssessmentService";
import TemplateService from "@/services/TemplateService";

import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import draggable from "vuedraggable";
import ConfigItemSearch from "@/components/ConfigItemSearch";

export default {
	name: "TemplateEdit",

	props: ["user", "params", "query"],

	components: {
		"assessment-edit-details": AssessmentEditDetails,
		"assessment-assign": AssessmentAssign,
		"item-edit-details": ItemEditDetails,
		"item-edit-scoring": ItemEditScoring,
		"item-edit-viewer": ItemEditViewer,
        "test-designer": TestDesigner,

		ConfigStandardSearch,
		EditPane,
		SaveOptionalModal,
		ConfigSelect,
		ConfigItemSearch,
		RichText,
		draggable
	},

	data() {
		return {
			fs: fs,
			assessment: {
				loaded: 0
			},
			tab: 1,
			defaultTab: 1,
			id: "tab_1",
			contentAreas: [],
			selectedContentArea: null,
			selectedItem: null,
			originalDesc: "",
			refresh: null,

			originalResources: [],
			isScored: false,
			grades: [],
			sGrades: null,
			RefIDs: [],
			isUnique: true,
			dirty: false,
			valid: {},
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	computed: {
		sRefID() {
			return this.assessment.ref_id;
		},
		sGradeIDs() {
			return _.map(this.sGrades, "id");
		}
	},

	created() {
		this.loadData();
		this.initValidation();

		if (this.query.tab) {
			this.tab = this.query.tab;
		}
	},

	watch: {
		"assessment.name"() {
			if (this.autoRef) {
				this.assessment.ref_id = this.generateAutoRef(this.assessment.name);
			}
		},
		"assessment.ref_id"() {
			this.checkAutoRef();
		},
    dirty(newVal) {
      console.log("dirty now ", this.assessment);
    },
    sRefID(newVal) {
      if(this.RefIDs.includes(newVal)){
        this.isUnique = false;

      }else {
        this.isUnique = true
        
      }
    },
    sGradeIDs(newVal) {
      let oldVal = this.assessment.grade_ids;
      if (oldVal == null) {
        oldVal = newVal.slice(0, newVal.length - 1);
      }
      let same = true;
      if (newVal.length == oldVal.length) {
        for (let i = 0; i < newVal.length; i++) {
          if (newVal[i] != oldVal[i]) {
            same = false;
          }
        }
      } else {
        same = false;
      }

      if (!same) {
        this.assessment.grade_ids = newVal;
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.dirty) {
      this.saveOptNext = () => {
        next();
      };
      this.saveOptCancel = () => {
        next(false);
      };
      this.saveOptModal = true;
    } else {
      next();
    }
  },

  methods: {
    initValidation() {
      this.valid = ValidationService.newValidator({
        name: {
          group: "details",
          errorMsg: "You must assign a name",
          func: () => {
            return (
              this.assessment &&
              this.assessment.name &&
              this.assessment.name != ""
            );
          }
        },
        ref: {
          group: "details",
          errorMsg: "You must assign a reference ID",
          func: () => {
            return (
              this.assessment &&
              this.assessment.ref_id &&
              this.assessment.ref_id != ""
            );
          }
        },
        ref_unique: {
          group: "details",
          errorMsg:
            "This Reference ID is already assigned to another Assessment",
          func: () => {
            return (
              this.assessment &&
              this.isUnique 
            );
          }
        },
        ref_char: {
          group: "details",
          errorMsg:
            "Reference IDs may not contain spaces or any of the following characters: ! # % ^ * ( )  / [ ] { } < > ? | ' \" :",
          func: () => {
            return (
              this.assessment &&
              this.assessment.ref_id &&
              fs.isGoodRefID(this.assessment.ref_id)
            );
          }
        },
        rubric: {
          group: "scoring",
          errorMsg: "You must choose a rubric",
          func: () => {
            return (
              this.assessment &&
              this.assessment.rubric &&
              this.assessment.rubric_id
            );
          }
        },
        type: {
          group: "scoring",
          errorMsg: "You must choose a resolution rule",
          func: () => {
            return this.assessment && this.assessment.type;
          }
        }
      });
    },
    removeItem(item) {
      this.assessment.assessment_items.pop(item);
    },
    resourceErr() {
      Notie.warning("Please save the assessment before uploading resources");
    },
    blankAssessment() {
      return {
        loaded: 0,
        standards: []
      };
    },

    watchChanges() {
      if (this.unwatch) {
        this.unwatch();
      }
      this.unwatch = this.$watch(
        "assessment",
        (newc, old) => {
          console.log("new assessment ", this.assessment.item.name);
          console.log("new assessment ", this.assessment.item.approved);
          console.log("new assessment ", this.assessment.item.standards);

          this.dirty = true;
        },
        { deep: true }
      );
    },
    blankItem() {
      return {
        validity_config: {},
        qualification_config: {},
        calibration_config: {},
        learnosity_config: {},
        crase_config: {},
        erater_config: {},
        api_export_config: {},
        exception_config: {},
        reliability_percent: 100,
        use_considerations: true,
        use_comments: true,
        resources: []
      };
    },
    loadData() {
      this.dirty = false;
      var loaded = this.assessment.loaded;
      loaded++;

      if (this.params.id != "new") {
        return BB.props({
          assessment: TemplateService.getTemplate(this.params.id),
        })
          .then(resps => {
            this.assessment = resps.assessment.data;
            
            this.watchChanges();
          })
          .catch(err => {
            console.log(err);
            Notie.error("template not found, adding new template instead");
            this.$router.replace("/templates/new");
          });
      } else {
        ContentAreaService.listContentAreas()
          .then(resp => {
            this.contentAreas = resp.data.content_areas;
            this.selectedContentArea = this.contentAreas[0];

            this.assessment = this.blankAssessment();
            this.assessment.loaded = loaded;
            this.$set(this.assessment, "name", "New Template");
            this.$set(this.assessment, "ref_id", "new_template");
            this.assessment.item = this.blankItem();
            this.$set(this.assessment.item, "name", "New Item");
            this.$set(this.assessment.item, "ref_id", "new_item");
            this.assessment.assessment_items = [];
            this.assessment.test = [];
            if(!this.assessment.student_notes){
              this.assessment.student_notes=[]
            }
            this.updateContentAreaID(this.selectedContentArea);
            this.watchChanges();
          })
          .catch(err => {
            Notie.error("Failed to load content areas");
          });
        GradeService.listGrades()
          .then(resp => {
            this.grades = resp.data;
          })
          .catch(err => {
            Notie.error("Failed to load grades");
          });
        AssessmentService.getRefIDs()
          .then(resp => {
            this.RefIDs = resp.data.RefIDs;
          })
          .catch(err => {
            Notie.error("Failed to load RefIDs");
          });
      }
    },

    updateContentAreaID(contentArea) {
      this.assessment.content_area_id = (contentArea && contentArea.id) || "";
    },
    LoadToItems() {
      this.assessment.item.rubric_id = this.assessment.rubric_id;
      this.assessment.item.rubric = this.assessment.rubric;
      this.assessment.item.type = this.assessment.type;
      this.assessment.item.standards = this.assessment.standards;
    },
    saveAssessment() {
      // debugger;
      this.LoadToItems();
      return TemplateService.saveTemplate(this.assessment)
        .then(resp => {
          console.log(
            "ITEM ",
            this.assessment.item.reliability_percent,
            this.assessment.item.individual_limit_percent
          );
          Notie.info("Template Saved");
          if (this.assessment.id != resp.data.id) {
            this.$router.replace("/templates/" + resp.data.id);
          }
          this.loadData();
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to save Template", err);
        });
    },

		checkAutoRef() {
			let genRef = this.generateAutoRef(this.assessment.name);
			this.autoRef = this.assessment.ref_id == genRef;
		},
		generateAutoRef(name) {
			return name && fs.toGoodRefID(name);
		},
		canSave() {
			return this.dirty;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/TemplateEdit.vue